<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-for="item in list" :key="item.userId" class="userRect">
      <div class="icon">
        <img :src="item.headIcon?item.headIcon:'/img/defaultUserIcon.jpg'">
      </div>
      <div class="info">
        <span>关系活动 </span>{{ item.groupName?item.groupName:(item.groupKey?item.groupKey:'默认活动') }}<br>
        <span>用户序号 </span>{{ item.userId }}<br>
        <span>用户姓名 </span>{{ item.userRealName }}<br>
        <span>用户昵称 </span>{{ item.userNickName }}<br>
        <span>推荐日期 </span>{{ formatDate(item.createTime,'yyyy/MM/dd hh:mm',true) }}
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '推荐人关系网络',
      backurl: '/my/index',
      list: []
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/activity/getUserRelationShipNetWorkList',
        method: 'post'
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.list = response.data
      })
    }
  }
}
</script>
<style scoped>
.userRect{
    height: 5em;
    padding: 1em;
    background-color: #fff;
    position: relative;
    margin-bottom: 0.5em;
}
.userRect .icon{
    width: 5em;
    height: 5em;
}
.userRect .icon img{
    width: 5em;
    height: 5em;
}
.userRect .info{
    position: absolute;
    left: 8em;
    top: 1em;
    font-size: 0.8em;
    font-weight: 700;
}
.userRect .info span{
    font-weight:normal;
}
</style>
